/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Removed_DescInputs */



/**
* | output |
* | --- |
* | "The member was removed from the organisation. Their personal space and project, and everything stored in them, were deleted." |
*
* @param {Audit_Details_Member_Removed_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_removed_desc = /** @type {((inputs?: Audit_Details_Member_Removed_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Removed_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Mitglied wurde aus der Organisation entfernt. Sein persönlicher Space und sein persönliches Projekt wurden mit allen darin gespeicherten Inhalten gelöscht.")
	return /** @type {LocalizedString} */ ("The member was removed from the organisation. Their personal space and project, and everything stored in them, were deleted.")
});